export const dataHooks = {
    analyticsSummaryCardCTA: 'analyticsSummaryCard-CTA',
    analyticsSummaryCardChart: 'analyticsSummaryCard-chart',
    analyticsSummaryCardLoader: 'analyticsSummaryCard-loader',
    analyticsSummaryCardTitle: 'analyticsSummaryCard-title',
    analyticsSummaryCardTitleTooltip: 'analyticsSummaryCard-title-tooltip',
    analyticsSummaryCardValue: 'analyticsSummaryCard-value',
    analyticsSummaryCardValueTooltip: 'analyticsSummaryCard-value-tooltip',
    analyticsSummaryCardTrend: 'analyticsSummaryCard-trend',
};
//# sourceMappingURL=constants.js.map